/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';
import dayjs from 'dayjs';
import { getGiorniChiusiLavorativo } from '../../../utility_objects/GiorniChiusiLavorativo';

/**
 * Gestisce la manipolazione DOM delle colonne nella vista WorkWeek:
 * - Nasconde i giorni di chiusura (width=0, getGiorniChiusiLavorativo)
 * - Allarga la colonna del giorno selezionato e del successivo
 *
 * Aspetta che isLoading sia false e usa un delay per girare
 * DOPO che Syncfusion ha completato il refresh() del DOM.
 * Riparte anche quando cambiano le ore mostrate (riga Ore del riquadro
 * Visualizzazione: Tutte | Prenotabili): Syncfusion ridisegna la vista e
 * ricrea le colonne con la larghezza di base.
 */
export function useWorkWeekColumns(
  view: string,
  selectedDate: Date,
  calendarPointOfSale: any,
  scheduleElementId: string,
  isLoading: boolean,
  startHour: number,
  endHour: number
) {
  useEffect(() => {
    if (view !== 'WorkWeek') return;
    if (isLoading) return;

    // Delay per assicurarsi che Syncfusion abbia completato refresh()
    // (useSchedulerRefresh usa setTimeout 100ms, questo gira dopo)
    const timeoutId = setTimeout(() => {
      const daysOfWeek =
        dayjs(selectedDate).day() !== 0 ? dayjs(selectedDate).day() - 1 : 6;

      const table = document.getElementById(scheduleElementId);
      if (table === null) return;

      const giorniChiusi = getGiorniChiusiLavorativo(
        selectedDate,
        calendarPointOfSale
      );

      const colgroup = document.getElementsByTagName('colgroup');
      if (colgroup !== null && colgroup.length > 0)
        for (let i = 0; i < colgroup.length; i++) {
          const children = colgroup[i].children;

          if (children && children.length === 7) {
            // Toglie i giorni di chiusura dal calendario
            giorniChiusi.forEach((chiuso, index) => {
              if (!chiuso) return;
              (children[index] as any).style.width = `0px`;
              (children[index] as any).style.overflow = `hidden`;
            });

            // Larghezza più grande per il giorno selezionato e il successivo
            const width = table.offsetWidth;
            if (daysOfWeek !== 6)
              if ((children[daysOfWeek + 1] as any).style.width !== '0px')
                (children[daysOfWeek + 1] as any).style.width = `${
                  width / 15
                }px`;
            (children[daysOfWeek] as any).style.width = `${width / 10}px`;
          }
        }
    }, 200);

    return () => clearTimeout(timeoutId);
  }, [
    view,
    selectedDate,
    calendarPointOfSale,
    scheduleElementId,
    isLoading,
    startHour,
    endHour,
  ]);
}
